/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { BotBank, BotBankInterface } from "../BotBank";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_assetsAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class BotBank__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BotBank> {
    return super.deploy(_assetsAddress, overrides || {}) as Promise<BotBank>;
  }
  getDeployTransaction(
    _assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_assetsAddress, overrides || {});
  }
  attach(address: string): BotBank {
    return super.attach(address) as BotBank;
  }
  connect(signer: Signer): BotBank__factory {
    return super.connect(signer) as BotBank__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BotBankInterface {
    return new utils.Interface(_abi) as BotBankInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BotBank {
    return new Contract(address, _abi, signerOrProvider) as BotBank;
  }
}
